import * as API from "@/services/API";

export default {
  getMain(Id) {
    return API.apiClient.get(`/dmain/${Id}`);
  },
  getMains() {
    return API.apiClient.get(`/dmain/`);
  },
  postMain(payload) {
    return API.apiClient.post(`/dmain/`, payload);
  },
  updateMain(Id, payload) {
    return API.apiClient.put(`/dmain/${Id}`, payload);
  },
  deleteMain(Id) {
    return API.apiClient.delete(`/dmain/${Id}`);
  },
};
